import { Text, TextProps } from '@chakra-ui/react';
import React from 'react';
import colors from '../../utils/colors';

interface HeadingProps extends TextProps {
    children: React.ReactNode;
    size?: "l" | "xl";
    color?: string
}

const Heading: React.FC<HeadingProps> = ({ children, size = "l", color, ...rest }) => {
    return <Text
        {...rest}
        fontSize={"32px"}
        fontFamily={"lato"}
        fontWeight={size === "xl" ? 700 : 400}
        color={color ?? colors.dark}
        lineHeight={"38.4px"}
    >
        {children}
    </Text>;
};

export default Heading;
